/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Author:    leo<zhudongxian@frippler.com>
  | @Title:     模块
  | @Version:   2020-01-08  [A] 新建文件
  +--------------------------------------------------------------------------------------
*/
import request from '@/utils/request'

export function moduleOpenStatus(params) {
  return request({
    url: '?c=module&a=open&do=status',
    method: 'get',
    params
  })
}

export function moduleOpenApply(data) {
  return request({
    url: '?c=module&a=open&do=apply',
    method: 'post',
    data
  })
}
